import React from 'react';
import { Button } from '../../components';
import s from './HostStyles.module.scss';

const ButtonHost = () => (
    <div className={s.editor} style={{ padding: '100px' }}>
        <Button label="Big black" big color="black" />
        <br />
        <br />
        <Button label="Big black disabled" disabled big color="black" />
        <br />
        <br />
        <Button label="Small blue" color="blue" />
        <br />
        <br />
        <Button label="Small blue disabled" disabled color="blue" />
    </div>
);

export default ButtonHost;
